import Hotjar from '@hotjar/browser';

import Widget from './widget';
import { FeatureFlagProvider } from './context/FeatureFlagContext';
import { isProductionStage } from './utils';

const siteId = 3430993;
const hotjarVersion = 6;

if (isProductionStage) {
  Hotjar.init(siteId, hotjarVersion);
}

export function App() {
  return (
    <FeatureFlagProvider>
      <Widget />
    </FeatureFlagProvider>
  );
}

export default App;
